import React from "react";
import { Button } from "@mui/material";

const DialogConfirmButton = ({ label = "Ok", onClick }) => {
    return <Button variant="contained" color="primary" onClick={onClick} size="small">{label}</Button>
}

export default DialogConfirmButton;
